export const EXSBDOCUMENT_SHOW_RESET = 'EXSBDOCUMENT_SHOW_RESET'
export const EXSBDOCUMENT_SHOW_SET_ERROR = 'EXSBDOCUMENT_SHOW_SET_ERROR'
export const EXSBDOCUMENT_SHOW_SET_RETRIEVED = 'EXSBDOCUMENT_SHOW_SET_RETRIEVED'
export const EXSBDOCUMENT_SHOW_TOGGLE_LOADING = 'EXSBDOCUMENT_SHOW_TOGGLE_LOADING'
